import { decode } from '@finn-no/safe-props';

const decodeDataProps = <T>(rootElement: HTMLElement | null): T | undefined => {
    const encodedDataset = rootElement?.dataset.props;
    if (!encodedDataset) return undefined;
    const decodedDataset = decode(encodedDataset) as T;
    return decodedDataset;
};

export default decodeDataProps;
